(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["steel-header"] && !Shopify.designMode) return;
  try {
    
const hamburger = document.querySelector('.steel-header__hamburger');
const drawer = document.querySelector('.mobile-drawer');
const overlay = document.querySelector('.mobile-drawer__overlay');
const closeBtn = document.querySelector('.mobile-drawer__close');

function openDrawer() {
drawer.classList.add('mobile-drawer--open');
overlay.classList.add('mobile-drawer__overlay--open');
document.body.style.overflow = 'hidden';
}

function closeDrawer() {
drawer.classList.remove('mobile-drawer--open');
overlay.classList.remove('mobile-drawer__overlay--open');
document.body.style.overflow = '';
}

hamburger.addEventListener('click', openDrawer);
closeBtn.addEventListener('click', closeDrawer);
overlay.addEventListener('click', closeDrawer);

  } catch(e) { console.error(e); }
})();
})();
